import type { LocalUser } from "@/lib/auth";

/**
 * Un apprenant porte `app_metadata.learner_id` et PAS de `tenant_id`
 * (les JWT staff portent tenant_id + role ; les JWT apprenant portent
 * learner_id à la place — cf. backend auth/jwt). Sert à rediriger un
 * apprenant connecté vers son espace /me plutôt que le back-office staff.
 */
export function isLearnerUser(user: LocalUser | null | undefined): boolean {
  const meta = user?.app_metadata;
  return Boolean(meta?.learner_id) && !meta?.tenant_id;
}
